import React, { Component } from "react";
import PropTypes from "prop-types";
import "./css/itemCountBadge.css";

class itemCountBadge extends Component {
  constructor() {
    super();
    this.state = {
      itemCount: 0,
      triggerAnimation: false
    };
  }

  componentWillMount() {
    if (this.props.itemCount) {
      this.setState({
        triggerAnimation: true,
        itemCount: this.props.itemCount
      });
    }
  }

  componentWillReceiveProps({ itemCount }) {
    this.setState({
      triggerAnimation: itemCount !== this.state.itemCount,
      itemCount
    });
  }

  render() {
    const classes = ["cart-badge"];
    if (this.state.triggerAnimation) {
      classes.push("cart-modified");
    }
    return (
      <div data-quid="item-count-badge" className={classes.join(" ")}>
        {this.state.itemCount}
      </div>
    );
  }
}

itemCountBadge.propTypes = {
  itemCount: PropTypes.string.isRequired
};

export default itemCountBadge;
